/**
 * Item Value Not String
 */
export default ['status', 'type', 'unit', 'offsetval', 'index', 'percent', 'manual', 'frequency'];
